import PageTitle from '../components/CommonComps/Titles/PageTitle';
import AppointmentOverview from '../components/DashboardComps/AppointmentOverview';
import AppointmentSummary from '../components/DashboardComps/AppointmentSummary';
import BookingHistory from '../components/DashboardComps/ClientDashboardComps/BookingHistory';
import ReviewsHistory from '../components/DashboardComps/ClientDashboardComps/ReviewsHistory';
import TransactionHistory from '../components/DashboardComps/ClientDashboardComps/TransactionHistory';
import ClientSummary from '../components/DashboardComps/ClientSummary';
import VacationHistory from '../components/DashboardComps/VacationHistory';
import { useAuthContext } from '../contexts/AuthProvider';

const Dashboard = () => {
  // integration of react hooks here
  const { currentUserType } = useAuthContext();

  // rendering dashboard page component here
  return (
    <>
      <PageTitle title='Dashboard' />

      <AppointmentOverview />
      <AppointmentSummary />

      {currentUserType === 'user' ? (
        <>
          <ClientSummary />
          <VacationHistory />
        </>
      ) : null}

      {currentUserType === 'client' ? (
        <>
          <TransactionHistory />
          <BookingHistory />
          <ReviewsHistory />
        </>
      ) : null}
    </>
  );
};

export default Dashboard;
